<template>
  <router-view />
</template>

<script setup lang="ts">
const $q = useQuasar()

if (me.value.type === userTypesEnum.Amministratore) {
  onKeyStroke('k', e => {
    if (!e.ctrlKey && !e.metaKey) return

    e.preventDefault()

    $q.dialog({
      component: defineAsyncComponent(() => import('components/dialogs/PageDialog.vue')),
    })
  })
}
</script>
